<template>
<div class="cambook-sidebar" ref="cambookSidebar">
  <div class="cambook-menu">
    <div class="cambook-menu-item flex items-center justify-start active" @click="toHome">
      <div class="menu-item__icon">
        <cam-icons :name="`bookShelf`" :size="18"/>
      </div>
      <div class="menu-item__desc">Bookshelf</div>
    </div>
    <!-- 兑换码入口（仅温肯模式显示） -->
    <div v-if="schoolStore.redeemEnabled" class="cambook-menu-item flex items-center justify-start" @click="showRedeemDialog = true">
      <div class="menu-item__icon">
        <cam-icons name="key" :size="18"/>
      </div>
      <div class="menu-item__desc">Redeem Code</div>
    </div>
    <div class="cambook-menu-item flex items-center justify-start " @click="toUser">
      <div class="menu-item__icon">
        <user-header-img
          :width="20"
          :text="StudentInfo?.englishName ? StudentInfo?.englishName.slice(0,1) : ''"
        />
      </div>
      <div class="menu-item__desc">{{StudentInfo?.englishName || ''}}</div>
    </div>
  </div>
  <div class="cambook-logout">
    <div class="cambook-menu-item cambook-logout-item flex items-center justify-start" @click="logout">
      <div class="menu-item__icon">
        <cam-icons name="logout" size="18" color="#4F6999"/>
      </div>
      <div class="menu-item__desc">Logout</div>
    </div>
  </div>
  <about-me-dialog
    v-model="showUser"
    v-if="showUser"
  />
  <redeem-code-dialog
    v-model="showRedeemDialog"
    @refresh-home-data="refreshHomeData"
  />
</div>
</template>

<script setup>
import CamIcons from '@/components/CamIcons/index.vue'
import AboutMeDialog from '@/layout/components/AboutMeDialog.vue'
import RedeemCodeDialog from '@/layout/components/RedeemCodeDialog.vue'
import UserStore from '@/stores/User.js'
import { useSchoolStore } from '@/stores/School.js'
import UserHeaderImg from '@/layout/components/UserHeaderImg.vue'
import { ref, computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
const router = useRouter()
const useUserStore = UserStore()
const schoolStore = useSchoolStore()
const UserInfo = computed(() => useUserStore.userInfo)
const StudentInfo = computed(() => useUserStore.studentInfo)
const cambookSidebar = ref(null)
const showUser = ref(false)
const showRedeemDialog = ref(false)

onMounted(() => {
  cambookSidebar.value.style.height = `${document.body.clientHeight - 130}px`
})

const logout = async () => {
  await useUserStore.LogOut()
}

const toHome = () => {
  router.push({
    path: '/home',
  })
}

const toUser = () => {
  showUser.value = true
}

const refreshHomeData = () => {
  // 刷新首页数据
  window.location.reload()
}

</script>

<style lang="scss" scoped>
.cambook-sidebar{
  flex: 0 0 200px;
  height: calc(100vh - 150px);
  position: sticky;
  top:90px;
}
.cambook-menu{
  width: 100%;
  height: calc(100% - 46px);
}
.cambook-menu-item{
  height: 36px;
  line-height: 36px;
  padding: 8px 28px;
  border-radius: 100px;
  cursor: pointer;
  margin-bottom: 22px;
  &:hover,
  &.active{
    background-color: #F8F8F8;
    .menu-item__desc{
      font-weight: bold;

    }
  }
  .menu-item__icon{
    flex: 0 0 20px;
    margin-right: 20px;
  }
}
.cambook-logout-item{
  margin-bottom: 0;
  background-color: #F8F8F8;
  font-weight: bold;
}
</style>
